import { CreateOrUpdateBaseService } from "../../common/services/createOrUpdateBase.service";
import { services } from "../../constants/services";

export interface Ilogin{
    email: string | any;
    password: any
}
export class LoginService extends CreateOrUpdateBaseService<Ilogin,any> {
    url = `${services.auth}/sign-in`;
}